import { Link } from "react-router-dom";
import { useBrand } from "@/hooks/useCatalogue";

export const LOGO = {
  full: "/brand/ela-logo.svg",
  fullLight: "/brand/ela-logo-ivory.png",
  mark: "/brand/ela-mark.png",
  markLight: "/brand/ela-mark-ivory.png",
};

export function BrandLogo({ variant = "full", tone = "dark", className = "" }) {
  const { data } = useBrand();
  const override = variant === "full" && tone === "dark" ? data?.logo_url : null;
  const src =
    override ||
    (variant === "mark"
      ? tone === "light" ? LOGO.markLight : LOGO.mark
      : tone === "light" ? LOGO.fullLight : LOGO.full);
  return (
    <img
      src={src}
      alt={variant === "mark" ? "ELA mark" : "ELA Rituals"}
      className={className}
      draggable={false}
    />
  );
}

export function BrandLockup({ tone = "dark", compact = false }) {
  const text = tone === "light" ? "text-ivory" : "text-forest";
  const sub = tone === "light" ? "text-champagne" : "text-champagne";
  return (
    <span className="inline-flex items-center gap-3">
      <BrandLogo variant="mark" tone={tone} className={compact ? "h-9 w-auto" : "h-11 w-auto"} />
      <span className="flex flex-col leading-none">
        <span className={`text-[13px] sm:text-sm uppercase tracking-[0.32em] font-medium ${text}`}>
          ELA Rituals
        </span>
        {!compact && (
          <span className={`mt-1.5 font-serif italic text-[13px] tracking-wide ${sub}`}>
            Rituals With You
          </span>
        )}
      </span>
    </span>
  );
}

export function BrandLogoLink() {
  return (
    <Link to="/" data-testid="navbar-brand-logo" className="inline-flex items-center" aria-label="ELA Rituals home">
      <BrandLockup />
    </Link>
  );
}
